import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgModule, Injectable, Optional, ɵɵdefineInjectable, ɵɵinject } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';
class AopConfig {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AopRoutingModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: AopRoutingModule,
            providers: [{ provide: AopConfig, useValue: config }],
        };
    }
}
AopRoutingModule.ɵfac = function AopRoutingModule_Factory(t) { return new (t || AopRoutingModule)(); };
AopRoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AopRoutingModule });
AopRoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AopRoutingModule, [{
        type: NgModule,
        args: [{
                imports: []
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const NavError = {
    OBSERVABLE_REQUIRED: 'To use route async, method must return an observable<string | NavAux>',
    OBSERVABLE_STREAM: 'Encountered error in observable stream',
    UPDATING_NAVAUX: 'Error updating NavAux instance',
    PREPROCRESS_FUNC: 'An error occurred executing function ',
    ROUTING: 'Could not route to ',
    LOCATION_BACK: 'Failed to popState navigate',
    STATE_HISTORY: 'Failed to load specific page from session history',
    EXPERIMENTAL_FEATURE_ROUTE_TRANSFORM: 'Cannot use RouteTransform object with experimental flag turned off',
    EXPERIMENTAL_FEATURE_COMPONENT_MISSING: 'No component provided to create a new route path object',
    EXPIREMENTAL_FEATURE_ROUTE_TRANSFORM: 'EXPIREMENTAL_FEATURE_ROUTE_TRANSFORM',
};
/** @enum {string} */
const AopRoute = {
    SKIP_ROUTE: 'Cancel Route',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Dummy service to allow custom implemenation of navigation logic.
 * Should be overriden by a custom navigation class inheriting BaseNavigation Class.
 * The custom navigation class should be provided by the angular injector through the `useClass` attribute
 * of the provider array.
 */
class AopProxyNavigationService {
    /**
     * @param {?} navObj
     * @param {...?} args
     * @return {?}
     */
    goToNextPage(navObj, ...args) { }
    /**
     * @param {?} navObj
     * @param {...?} args
     * @return {?}
     */
    goToPreviousPage(navObj, ...args) { }
    /**
     * @param {?} navObj
     * @param {...?} args
     * @return {?}
     */
    goToState(navObj, ...args) { }
}
AopProxyNavigationService.ɵfac = function AopProxyNavigationService_Factory(t) { return new (t || AopProxyNavigationService)(); };
AopProxyNavigationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AopProxyNavigationService, factory: AopProxyNavigationService.ɵfac, providedIn: 'root' });
/** @nocollapse */ AopProxyNavigationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AopProxyNavigationService_Factory() { return new AopProxyNavigationService(); }, token: AopProxyNavigationService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AopProxyNavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class AopBaseNavigation {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic//
class Transient {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Determines if the passed value is a string.
 * @param {?} value - value to perform operation on
 * @return {?}
 */
function isTypeString(value) {
    return typeof value === 'string';
}
/**
 * Determins if passed string value is an empty string.
 * @param {?} value - value to perform operation on
 * @return {?}
 */
function isEmptyString(value) {
    return value === '';
}
/**
 * Determines if the passed value is a number.
 * @param {?} value - value to perform operation on
 * @return {?}
 */
function isTypeNumber(value) {
    return typeof value === 'number';
}
/**
 * Determines if the passed argument is defined and is also an instance of `AopBaseNavigation`
 * @param {?} proxyNavRef - proxy service
 * @return {?}
 */
function isProxyNavigationProvided(proxyNavRef) {
    return proxyNavRef && proxyNavRef instanceof AopBaseNavigation;
}
/**
 * Determines if the passed object is of type `AopNav` by searching for a
 * `routeTransform` property.
 * @param {?} navObj - javascript object
 * @return {?}
 */
function isAopNavObj(navObj) {
    if (navObj) {
        if (Transient.useExperimentalFeatures) {
            return 'routeTransform' in navObj;
        }
        else if (!Transient.useExperimentalFeatures && 'routeTransform' in navObj) {
            logError(createErrorObj(NavError.EXPIREMENTAL_FEATURE_ROUTE_TRANSFORM));
            throw NavError.EXPIREMENTAL_FEATURE_ROUTE_TRANSFORM;
        }
    }
    return false;
}
/**
 * Creates an `Error` object with the passed string.
 * @param {?} errorMsg - message used to construct Error object
 * @return {?}
 */
function createErrorObj(errorMsg) {
    /** @type {?} */
    const err = new Error(errorMsg);
    err.name = 'aop-routing Error';
    return err;
}
/**
 * Logs error to the console.
 * @param {?} error - Error object
 * @return {?}
 */
function logError(error) {
    console.error(error);
}
/**
 *  returns the value of the first element in the provided array that satisfies the provided testing function.
 *  If no values satisfies the testing function, undefined is returned.
 *
 * @param {?} array - array to search on
 * @param {?} item - item to search for
 * @return {?}
 */
function findElementInArray(array, item) {
    return array.find((/**
     * @param {?} element
     * @return {?}
     */
    (element) => element.path === item));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic//
class RouteHelper {
    /**
     * Alters route table by either adding a new route path, change route component or updating canActivate guards.
     * @param {?} router - Router object
     * @param {?} routeTransform
     * @return {?}
     */
    static modifyRouteTable(router, routeTransform) {
        this.pristineRouteConfig = cloneDeep(router.config);
        /** @type {?} */
        const pathObj = this.getRoutePathObj(router, routeTransform.path);
        if (!pathObj && (routeTransform.path && routeTransform.component)) {
            this.addNewRoutePath(router, routeTransform.path, routeTransform.component, routeTransform.canActivateGuards);
        }
        else {
            if (routeTransform.component) {
                this.changeRouteComponent(router, routeTransform.path, routeTransform.component);
            }
            if (routeTransform.canActivateGuards) {
                this.updateCanActivateGuards(router, routeTransform.path, routeTransform.canActivateGuards);
            }
        }
    }
    /**
     * Creates a Route object and adds it to the Router table.
     * @param {?} router - Router object
     * @param {?} path - Path name
     * @param {?} component  - Component to be attached.
     * @param {?=} canActivate - List of guards
     * @return {?}
     */
    static addNewRoutePath(router, path, component, canActivate = []) {
        if (component) {
            /** @type {?} */
            const routeInput = { path, component, canActivate };
            router.config.push(routeInput);
        }
        else {
            logError(createErrorObj(NavError.EXPERIMENTAL_FEATURE_COMPONENT_MISSING));
            throw NavError.EXPERIMENTAL_FEATURE_COMPONENT_MISSING;
        }
    }
    /**
     * Modifies the existing path to point to the passed component.
     * @param {?} router - Router object
     * @param {?} path - Path name
     * @param {?} component - Component to be attached.
     * @return {?}
     */
    static changeRouteComponent(router, path, component) {
        this.getRoutePathObj(router, path).component = component;
    }
    /**
     * Will update canActivate guards on route path. If an empty array of guards is passed, guards on the route will be disabled.
     * if list of guards is passed, they will be added to existing canActivate guards.
     * @param {?} router - Router object
     * @param {?} path - Path name
     * @param {?} guard - list of guards
     * @return {?}
     */
    static updateCanActivateGuards(router, path, guard) {
        if (guard && guard.length > 0) {
            this.addOrRemoveCanActivateGuard(router, path, guard);
        }
        else if (guard.length === 0) {
            this.disableCanActivateGuards(router, path);
        }
    }
    /**
     * Removes all all guards for canActivate.
     * @param {?} router - Router object
     * @param {?} path - Path name
     * @return {?}
     */
    static disableCanActivateGuards(router, path) {
        this.getRoutePathObj(router, path).canActivate = [];
    }
    /**
     * Will add canActivate guards to existing route path. IF there are no existing canActivate guards
     * a new array will be created.
     * @param {?} router - Router object
     * @param {?} path - Path name
     * @param {?} guard - guards array
     * @return {?}
     */
    static addOrRemoveCanActivateGuard(router, path, guard) {
        if (this.getRoutePathObj(router, path)) {
            if (!this.getRoutePathObj(router, path).canActivate) {
                this.getRoutePathObj(router, path).canActivate = guard;
            }
            else {
                /** @type {?} */
                const clonedActivatedGuards = this.isCanActivateGuardExist(router, path, guard);
                /** @type {?} */
                const updatedCanActivatedGuards = [...clonedActivatedGuards, ...guard];
                this.getRoutePathObj(router, path).canActivate = updatedCanActivatedGuards;
            }
        }
    }
    /**
     * Returns a Route object from the router table array.
     * @param {?} router - Router object
     * @param {?} path - path name to search
     * @return {?}
     */
    static getRoutePathObj(router, path) {
        /** @type {?} */
        let pathObj = findElementInArray(router.config, path);
        if (!pathObj) {
            //traverse through children routes if any
            for (let i = 0; i < router.config.length; i++) {
                if (router.config[i].children) {
                    pathObj = this.searchChildRoutes(router.config[i].children, path);
                    if (pathObj) {
                        break;
                    }
                }
            }
        }
        return pathObj;
    }
    /**
     *
     * @param {?} childRoutes - children routes array
     * @param {?} path - path name to search
     * @return {?}
     */
    static searchChildRoutes(childRoutes, path) {
        return findElementInArray(childRoutes, path);
    }
    /**
     * @param {?} router
     * @param {?} path
     * @param {?} guards
     * @return {?}
     */
    static isCanActivateGuardExist(router, path, guards) {
        /** @type {?} */
        const clonedCanActivateGuards = cloneDeep(this.getRoutePathObj(router, path).canActivate);
        /** @type {?} */
        const removeGuardsIndex = [];
        // Check if guards exist
        for (let element = 0; element < guards.length; element++) {
            /** @type {?} */
            const guardIndex = clonedCanActivateGuards.findIndex((/**
             * @param {?} x
             * @return {?}
             */
            (x) => {
                return x === guards[element];
            }));
            if (guardIndex !== -1) {
                removeGuardsIndex.push(guardIndex);
            }
        }
        // Trim passed guards array and only leave guard to added
        for (let element = 0; element < removeGuardsIndex.length; element++) {
            guards.splice(removeGuardsIndex[element], 1);
        }
        // Remove existing guards from cloned guards based on the passed values
        for (let elementToRemove = 0; elementToRemove < removeGuardsIndex.length; elementToRemove++) {
            clonedCanActivateGuards.splice(removeGuardsIndex[elementToRemove], 1);
        }
        return clonedCanActivateGuards;
    }
    /**
     * Points route config back to existing configuration.
     * @param {?} router - Router object
     * @return {?}
     */
    static resetRouterConfig(router) {
        router.config = this.pristineRouteConfig;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic//
class AopNavigationService {
    /**
     * @param {?} router
     * @param {?} location
     * @param {?=} proxyNavigationService
     * @param {?=} config
     */
    constructor(router, location, proxyNavigationService, config) {
        this.router = router;
        this.location = location;
        this.proxyNavigationService = proxyNavigationService;
        if (config) {
            Transient.useExperimentalFeatures = config.expirementNav;
        }
        AopNavigationService.routerRef = this.router;
        AopNavigationService.locationRef = this.location;
        AopNavigationService.proxyNavRef = this.proxyNavigationService;
    }
    /**
     * Performs action to call router navigate method and uses the destinationPage property of the NavAux instance
     * to route to next page. If preprocess property of NavAux is provided, it will be executed prior to route navigation.
     * If a ProxyNavigationService token is present it will use the goToNextPage implementation of the ProxyNavigationService instead.
     *
     * @param {?} navObj - Instance of NavAux class
     * @return {?}
     */
    static goToNextPage(navObj) {
        if (isProxyNavigationProvided(this.proxyNavRef)) {
            this.proxyNavRef.goToNextPage(navObj);
        }
        else {
            if (navObj && navObj.preprocess) {
                this.executePreProcessLogic(navObj.preprocess, navObj.param);
            }
            if (isAopNavObj(navObj)) {
                RouteHelper.modifyRouteTable(this.routerRef, navObj.routeTransform);
                this.executeImperativeNavigation(navObj);
                RouteHelper.resetRouterConfig(this.routerRef);
            }
            else {
                this.executeImperativeNavigation(navObj);
            }
        }
    }
    /**
     * Performs action to call the back method of the Location service. If preprocess property of NavAux is provided, it will be executed
     * prior to the execution of the back method.
     * If a ProxyNavigationService token is present it will use the goToPreviousPage implementation of the ProxyNavigationService instead.
     * @param {?} navObj - Instance of NavAux class
     * @return {?}
     */
    static goToPreviousPage(navObj) {
        if (isProxyNavigationProvided(this.proxyNavRef)) {
            this.proxyNavRef.goToPreviousPage(navObj);
        }
        else {
            if (navObj && navObj.preprocess) {
                this.executePreProcessLogic(navObj.preprocess, navObj.param);
            }
            try {
                this.locationRef.back();
            }
            catch (e) {
                logError(createErrorObj(NavError.LOCATION_BACK));
                throw e;
            }
        }
    }
    /**
     * Performs action to call the go method of the History object. If preprocess property of NavAux is provided, it will be executed
     * prior to the execution of the go method.
     * If a ProxyNavigationService token is present it will use the goToState implementation of the ProxyNavigationService instead.
     * @param {?} navObj - Instance of NavAux class
     * @return {?}
     */
    static goToState(navObj) {
        if (isProxyNavigationProvided(this.proxyNavRef)) {
            this.proxyNavRef.goToState(navObj);
        }
        else {
            if (navObj && navObj.preprocess) {
                this.executePreProcessLogic(navObj.preprocess, navObj.param);
            }
            try {
                if (isTypeNumber(navObj.destinationPage)) {
                    history.go((/** @type {?} */ (navObj.destinationPage)));
                }
            }
            catch (e) {
                logError(createErrorObj(NavError.STATE_HISTORY));
                throw e;
            }
        }
    }
    /**
     * Returns a router object.
     * @return {?}
     */
    static getRouterObj() {
        return this.routerRef;
    }
    /**
     * Returns a location object.
     * @return {?}
     */
    static getLocationObj() {
        return this.locationRef;
    }
    /**
     * @param {?} navObj
     * @return {?}
     */
    static executeImperativeNavigation(navObj) {
        /** @type {?} */
        const destinationPage = isEmptyString(navObj.destinationPage) ? navObj.destinationPage : navObj.destinationPage || navObj.routeTransform.path;
        if (isTypeString(destinationPage)) {
            try {
                this.routerRef.navigate([destinationPage], navObj.navigationExtra);
            }
            catch (e) {
                logError(createErrorObj(NavError.ROUTING + destinationPage));
                throw e;
            }
        }
    }
    /**
     * Executes the passed function reference. Passed param property will be used as function argument.
     * @param {?} preProcessFunc - Function reference
     * @param {?} param - Parameter to be used for the function
     * @return {?}
     */
    // tslint:disable-next-line:ban-types
    static executePreProcessLogic(preProcessFunc, param) {
        try {
            if (preProcessFunc) {
                param ? preProcessFunc(param) : preProcessFunc();
            }
        }
        catch (e) {
            logError(createErrorObj(NavError.PREPROCRESS_FUNC + preProcessFunc.name));
            throw e;
        }
    }
}
AopNavigationService.ɵfac = function AopNavigationService_Factory(t) { return new (t || AopNavigationService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc2.Location), ɵngcc0.ɵɵinject(AopProxyNavigationService, 8), ɵngcc0.ɵɵinject(AopConfig, 8)); };
AopNavigationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AopNavigationService, factory: AopNavigationService.ɵfac, providedIn: 'root' });
/** @nocollapse */
AopNavigationService.ctorParameters = () => [
    { type: Router },
    { type: Location },
    { type: AopProxyNavigationService, decorators: [{ type: Optional }] },
    { type: AopConfig, decorators: [{ type: Optional }] }
];
/** @nocollapse */ AopNavigationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AopNavigationService_Factory() { return new AopNavigationService(ɵɵinject(Router), ɵɵinject(Location), ɵɵinject(AopProxyNavigationService, 8), ɵɵinject(AopConfig, 8)); }, token: AopNavigationService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AopNavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.Location }, { type: AopProxyNavigationService, decorators: [{
                type: Optional
            }] }, { type: AopConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class to encapsulate extra navigation properties or methods that's required to execute the navigation process.
 */
class NavAux {
    /**
     * @param {?=} destinationPage
     * @param {?=} navigationExtra
     * @param {?=} preprocess
     * @param {?=} param
     */
    constructor(destinationPage, navigationExtra, preprocess, param) {
        this.destinationPage = destinationPage;
        this.navigationExtra = navigationExtra;
        this.preprocess = preprocess;
        this.param = param;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Calls the `createNavObj` or `updateNavObj` to create an instance of the NavAux class with the passed in parameters.
 * @param {?} result - Result of executed function
 * @param {?=} page - Destination page
 * @param {?=} navigationExtras - Router navigation extra properties
 * @return {?}
 */
function prepareNavObject(result, page, navigationExtras) {
    /** @type {?} */
    let navObj;
    if (isAopNavObj(result)) {
        return {
            navAux: createNavObj(result.routeTransform.path, result.navigationExtra),
            routeTransform: result.routeTransform,
        };
    }
    if (page || isEmptyString((/** @type {?} */ (page)))) {
        navObj = createNavObj(page, navigationExtras);
    }
    if (typeof result === 'object') {
        navObj = updateNavObj(navObj, result);
    }
    return navObj;
}
/**
 * Creates an instance of the NavAux class by using the passed parameters.
 * @param {?} page - Destination page
 * @param {?} navigationExtras - Router extra properties
 * @return {?}
 */
function createNavObj(page, navigationExtras) {
    return new NavAux(page, navigationExtras);
}
/**
 * Will updated the existing instance of the NavAux to a new NavAux instance.
 * @param {?} oldNavObj - Exsting instance of NavAux class
 * @param {?} newNavObj - New Instance of NavAux class
 * @return {?}
 */
function updateNavObj(oldNavObj, newNavObj) {
    if (oldNavObj) {
        if (newNavObj.destinationPage) {
            oldNavObj.destinationPage = newNavObj.destinationPage;
        }
        if (newNavObj.navigationExtra) {
            oldNavObj.navigationExtra = newNavObj.navigationExtra;
        }
        if (newNavObj.preprocess) {
            oldNavObj.preprocess = newNavObj.preprocess;
        }
        if (newNavObj.param) {
            oldNavObj.param = newNavObj.param;
        }
        return oldNavObj;
    }
    return newNavObj;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Executes the original wrapped method and uses the return value along with the passed in arguments of the decorator
 * to create an instance of the NavAux class, then proceeds to navgigate to destination page.
 * @param {?=} page - Destination page
 * @param {?=} navigationExtras - Extra properties for the Router
 * @return {?}
 */
function RouteNext(page, navigationExtras) {
    return (/**
     * @param {?} target
     * @param {?} propertyKey
     * @param {?} descriptor
     * @return {?}
     */
    function (target, propertyKey, descriptor) {
        /** @type {?} */
        const originalMethod = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            /** @type {?} */
            const result = originalMethod.apply(this, args);
            if (result !== AopRoute.SKIP_ROUTE) {
                /** @type {?} */
                let navObj;
                if (isTypeString(result)) {
                    page = isEmptyString(result) ? result : result || page;
                    navObj = prepareNavObject(undefined, page, navigationExtras);
                }
                else {
                    navObj = prepareNavObject(result, page, navigationExtras);
                }
                AopNavigationService.goToNextPage(navObj);
            }
        });
    });
}
/**
 * Subscribes to wrapped method and uses its returned value to perform
 * imperative navigation.
 * @return {?}
 */
function RouteNextAsync() {
    return (/**
     * @param {?} target
     * @param {?} propertyKey
     * @param {?} descriptor
     * @return {?}
     */
    function (target, propertyKey, descriptor) {
        /** @type {?} */
        const originalMethod = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            try {
                originalMethod
                    .apply(this, args)
                    .pipe(take(1))
                    .subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    /** @type {?} */
                    let navObj;
                    if (isTypeString(result)) {
                        navObj = prepareNavObject(undefined, result);
                    }
                    else {
                        navObj = prepareNavObject(result);
                    }
                    AopNavigationService.goToNextPage(navObj);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    logError(createErrorObj(NavError.OBSERVABLE_STREAM));
                    throw new Error(error);
                }));
            }
            catch (error) {
                logError(createErrorObj(NavError.OBSERVABLE_REQUIRED));
                throw new Error(error);
            }
        });
    });
}
/**
 * Executes the original wrapped method and uses the return value to create an instance of the NavAux class. Then proceeds
 * to navigate backwards using popState.
 *
 * @return {?}
 */
function RouteBack() {
    return (/**
     * @param {?} target
     * @param {?} propertyKey
     * @param {?} descriptor
     * @return {?}
     */
    function (target, propertyKey, descriptor) {
        /** @type {?} */
        const originalMethod = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            /** @type {?} */
            const result = originalMethod.apply(this, args);
            /** @type {?} */
            const navObj = prepareNavObject(result);
            AopNavigationService.goToPreviousPage(navObj);
        });
    });
}
/**
 * Subscribes to wrapped method and at the end of execution will use popstate
 * navigation to navigate to the previous page.
 * @return {?}
 */
function RouteBackAsync() {
    return (/**
     * @param {?} target
     * @param {?} propertyKey
     * @param {?} descriptor
     * @return {?}
     */
    function (target, propertyKey, descriptor) {
        /** @type {?} */
        const originalMethod = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            try {
                originalMethod
                    .apply(this, args)
                    .pipe(take(1))
                    .subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    /** @type {?} */
                    const navObj = prepareNavObject(result);
                    AopNavigationService.goToPreviousPage(navObj);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    logError(createErrorObj(NavError.OBSERVABLE_STREAM));
                    throw new Error(error);
                }));
            }
            catch (error) {
                logError(createErrorObj(NavError.OBSERVABLE_REQUIRED));
                throw new Error(error);
            }
        });
    });
}
/**
 * Executes the original wrapped method and uses the return value along with the passed in arguments of the decorator
 * to create an instance of the NavAux class, then proceeds to traverse through the history to the specified state.
 * @param {?=} state - page in the state to navigate to
 * @return {?}
 */
function RouteToState(state) {
    return (/**
     * @param {?} target
     * @param {?} propertyKey
     * @param {?} descriptor
     * @return {?}
     */
    function (target, propertyKey, descriptor) {
        /** @type {?} */
        const originalMethod = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            /** @type {?} */
            const result = originalMethod.apply(this, args);
            /** @type {?} */
            const navObj = prepareNavObject(result, state);
            AopNavigationService.goToState(navObj);
        });
    });
}
/**
 * Subscribes to wrapped method and uses its returned value to perform popstate
 * navigation to a specific state in the browser history.
 * @return {?}
 */
function RouteToStateAsync() {
    return (/**
     * @param {?} target
     * @param {?} propertyKey
     * @param {?} descriptor
     * @return {?}
     */
    function (target, propertyKey, descriptor) {
        /** @type {?} */
        const originalMethod = descriptor.value;
        descriptor.value = (/**
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            try {
                originalMethod
                    .apply(this, args)
                    .pipe(take(1))
                    .subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    /** @type {?} */
                    let navObj;
                    if (isTypeNumber(result)) {
                        navObj = prepareNavObject(undefined, result);
                    }
                    else {
                        navObj = prepareNavObject(result);
                    }
                    AopNavigationService.goToState(navObj);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                (error) => {
                    logError(createErrorObj(NavError.OBSERVABLE_STREAM));
                    throw new Error(error);
                }));
            }
            catch (error) {
                logError(createErrorObj(NavError.OBSERVABLE_REQUIRED));
                throw new Error(error);
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { RouteNext, RouteBack, RouteToState, RouteNextAsync, RouteBackAsync, RouteToStateAsync, NavAux, AopConfig, AopNavigationService, AopBaseNavigation, AopProxyNavigationService, AopRoute, AopRoutingModule };

